import { render, staticRenderFns } from "./ProductProposal.vue?vue&type=template&id=b62f206a&scoped=true"
import script from "./ProductProposal.vue?vue&type=script&lang=ts"
export * from "./ProductProposal.vue?vue&type=script&lang=ts"
import style0 from "./ProductProposal.vue?vue&type=style&index=0&id=b62f206a&prod&lang=scss&scoped=true"
import style1 from "./ProductProposal.vue?vue&type=style&index=1&id=b62f206a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62f206a",
  null
  
)

export default component.exports